import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
// import useClickOutside from '../../hooks/useClickOutside';
import useClickOutside from '../UseClickOutside';

const Dropdown2 = React.memo(({ isOpen, children, onClose }) => {
  const dropdownRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile screen
  const updateDimensions = () => {
    const isMobileScreen = window.innerWidth < 768;
    setIsMobile(isMobileScreen);
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  // ✅ Outside click handler
  // useClickOutside(dropdownRef, () => {
  //   if (isOpen) {
  //     onClose?.();
  //   }
  // });

  if (!isOpen) return null;

  return (
    <motion.div
      ref={dropdownRef}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      className="fixed top-30 left-0 right-0 z-50 flex justify-center"
    >
      <div
        className={`bg-[#35373A] rounded-[20px] mt-10 max-h-[500px] overflow-y-auto ${
          isMobile ? 'w-full' : 'w-auto'
        } md:h-fit scrollbar`}
      >
        {children}
      </div>
    </motion.div>
  );
});

export default Dropdown2;
